module.exports = __webpack_public_path__ + "static/media/helengeli-19.d2fe0666.jpg";